import { AsyncOpService } from 'util/services/asyncOpService';
import { AsyncOpStatusCheck, CompletedAsyncOp, AsyncOpHandle } from 'util/domain';

export interface FullTextSearchHit {
	Id: number;
	DocumentName: string;
	HitHighlights: string[];
	Owner?: number;
}


export interface FullTextSearchResults {
	Self: string;
	Result: {
		Owned: FullTextSearchHit[];
		Shared: FullTextSearchHit[];
	};
}

export interface SearchParameters {
	SearchString: string;
	OwnerIds?: number[];
	ContentTypeCategories?: string[];
	Tags?: string[]
}

export class SearchBuilder {
	private queryText: string = '';
	private users: number[] = [];
	private fileTypes: string[] = [];
	private tags: string[] = [];

	public setQueryText(text: string) {
		this.queryText = text;
		return this;
	}

	public addUser(userId: number) {
		this.users = this.users.concat(userId);
		return this;
	}

	public removeUser(userId: number) {
		this.users = this.users.filter(u => u !== userId);
		return this;
	}

	public addFileType(fileType: string) {
		this.fileTypes = this.fileTypes.concat(fileType);
		return this;
	}

	public removeFileType(fileType: string) {
		this.fileTypes = this.fileTypes.filter(f => f !== fileType);
		return this;
	}

	public addTag(tag: string) {
		this.tags = this.tags.concat(tag);
		return this;
	}

	public removeTag(tag: string) {
		this.tags = this.tags.filter(t => t !== tag);
		return this;
	}

	public reset() {
		this.queryText = '';
		this.tags = [];
		this.users = [];
		this.fileTypes = [];
	}

	public build(): SearchParameters {

		return {
			SearchString: this.queryText || '',
			OwnerIds: this.users || [],
			ContentTypeCategories: this.fileTypes || [],
			Tags: this.tags || []
		};
	}
}

interface StatusResponse {
	Link: { Url: string };
	Self: string;
	Status: 'InProgress' | 'Available'
}

const isStatus = (s: any): s is StatusResponse => typeof s.Status === 'string' && typeof s.Link === 'object';

export class FullTextSearchService {
	public static readonly $inject = [
		'$q',
		'$http',
		'asyncOpService',
		'settingsService'
	];

	constructor(
		private readonly $q: ng.IQService,
		private readonly $http: ng.IHttpService,
		private readonly asyncOpService: AsyncOpService,
		private readonly settingsService: { serverAPIPath: string }
	) { }

	public search(query: SearchParameters): ng.IPromise<any> {
		let url = this.settingsService.serverAPIPath + '/async/fulltextsearch';
		let count = 0;

		return this.$http.post<any>(url, query)
			.then(res => this.asyncOpService.getStatusUntilComplete<StatusResponse, string>(res.headers("Location"), {
				isComplete: status => isStatus(status) && status.Status === 'Available',
				interval: 250,
				resultTransform: res => res.data.Link.Url
			}))
			.then(handle => {
				return handle.status
					.then(result => typeof result === 'string' ? this.$http.get<FullTextSearchResults>(result) : null)
			})
			.then(res => {
				let data = res.data;
				if (res.data === null) {
					return {
						Self: '',
						Result: { Owned: [], Shared: [] }
					};
				}

				data.Result.Owned = JSON.parse((data as any).Result.Owned);
				data.Result.Shared = JSON.parse((data as any).Result.Shared);
				return data;
			});

		
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/services/fullTextSearchService.ts